import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Subject } from "rxjs";
import _ from "lodash";

import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { HouseOrderGuestService } from "./house-order-guest/house-order-guest.service";
import {
  PageName,
  PAGES_NAME,
  SwitchPageService,
} from "@root/router/component/order-detail-sidebar/switch-page.service";
import { MultiHouseCalendarService } from "../calendar/multi-house-calendar/multi-house-calendar.service";

export type Operate = "CreateHourOrder";

@Component({
  selector: "host-house-order-detail",
  templateUrl: "./house-order-detail.component.html",
  styleUrls: ["./house-order-detail.component.scss"],
})
export class HouseOrderDetailComponent implements OnInit, OnChanges, OnDestroy {
  _code;
  @Input()
  get code() {
    return this._code;
  }
  set code(value) {
    console.log("code change: ", value);
    this._code = value;
    if (value) {
      this.fetchResvDetail();
    }
  }
  @Input() activatedIndex = 0;
  @Input() pageType: "sidebar" | "modal" = "sidebar";
  @Input() backArrow = false;

  @Output() onUpdate = new EventEmitter();
  @Output() onOperate = new EventEmitter<{ operate: Operate; payload: any }>();

  orderDetail;
  loading = false;
  selectedIndex = null;

  private destroy$ = new Subject();

  constructor(
    private cdr: ChangeDetectorRef,
    private orderService: OrderV2Service,
    private calendarService: MultiHouseCalendarService,
    private switchPageService: SwitchPageService,
  ) {}

  ngOnInit() {
    this.getOptions();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["code"] && changes["code"].currentValue) {
      console.log("codeChange: ", this.code);
    }
  }

  checkTab(index) {
    this.selectedIndex = index;
  }

  getOptions() {
    this.orderService.getSettings().subscribe((res) => {
      if (res.error_code === 0) {
        const settingOptions = _.get(res, "data");
        this.orderService.gethouseStatusSettingOptions().emit(settingOptions);
      }
    });
  }

  fetchResvDetail() {
    this.loading = true;
    this.orderService.getOrderDetail({ reservation_code: this.code, format: "v_2" }).subscribe((res) => {
      if (res.error_code === 0) {
        this.orderDetail = res.data.reservation;

        /**
         * @todo
         * @compact
         * ready to zoneless
         */
        this.cdr.markForCheck();
      }
    });
  }

  refreshModal(e) {
    if (e) {
      this.fetchResvDetail();
      this.orderService.updateOrderListRefresh(true);
      this.calendarService.refresh();

      this.onUpdate.emit();
    }
  }

  onCreateHourOrder(params) {
    this.onOperate.emit({
      operate: "CreateHourOrder",
      payload: params,
    });
  }

  changeOrder(message) {
    this.code = message.code;
    this.fetchResvDetail();
  }

  back() {
    this.switchPageService.go(0);

    const params = {
      house: {
        id: _.get(this.orderDetail, "house_id"),
        house_title: _.get(this.orderDetail, "house_title"),
      },
      date: _.get(this.orderDetail, "check_in"),
    };
    this.calendarService.displayHourReservationSidebar(params);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
